/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VoucherDisambiguazioneItemDTO } from './voucher-disambiguazione-item-dto';


export interface ExceptionResponseWithVoucherListDTO { 
    code?: number;
    message?: string;
    key?: string;
    voucher?: Array<VoucherDisambiguazioneItemDTO>;
}

